import { ethers } from "ethers";
const MOBILE_USERKEY_SIGNATURE_KEY = "mobile_userKey_signature";
if (typeof localStorage !== 'undefined' && !localStorage.getItem('mobile_encryption_v2_checksum')) {
    localStorage.removeItem(MOBILE_USERKEY_SIGNATURE_KEY);
    localStorage.setItem('mobile_encryption_v2_checksum', '1');
}
export const getSymmetricKey = async (signMessageAsync, walletAddress, assertCurrent = () => { }) => {
    const signature = getKeySignature();
    let key;
    if (signature === null) {
        key = await createSymmetricKey(signMessageAsync, walletAddress, assertCurrent);
    }
    else {
        key = await createFromSignature(signature);
        assertCurrent();
    }
    return key;
};
export const hasSavedSymmetricKey = () => {
    return getKeySignature() !== null;
};
export const getKeySignature = () => {
    return localStorage.getItem(MOBILE_USERKEY_SIGNATURE_KEY);
};
export const clearKeySignature = () => {
    localStorage.removeItem(MOBILE_USERKEY_SIGNATURE_KEY);
};
export const getSymmetricKeyChallenge = (walletAddress) => {
    const checksummedAddress = ethers.utils.getAddress(walletAddress);
    return `This static text will be used to derive encryption key for ${checksummedAddress}`;
};
export const storeKeySignature = (signature) => {
    localStorage.setItem(MOBILE_USERKEY_SIGNATURE_KEY, signature);
};
const createSymmetricKey = async (signMessageAsync, walletAddress, assertCurrent) => {
    const checksummedAddress = ethers.utils.getAddress(walletAddress);
    console.log('[MobileEncryption] Using checksummed address for key derivation:', checksummedAddress);
    const challenge = `This static text will be used to derive encryption key for ${checksummedAddress}`;
    const signature = await signMessageAsync({ message: challenge });
    assertCurrent();
    localStorage.setItem(MOBILE_USERKEY_SIGNATURE_KEY, signature);
    const key = await createFromSignature(signature);
    assertCurrent();
    return key;
};
async function createFromSignature(signature) {
    const hashBuffer = await crypto.subtle.digest("SHA-256", new TextEncoder().encode(signature));
    const keyMaterial = new Uint8Array(hashBuffer);
    const symmetricKey = await crypto.subtle.importKey("raw", keyMaterial, { name: "AES-GCM" }, true, ["encrypt", "decrypt"]);
    return symmetricKey;
}
export async function decryptData(symmetricKey, combinedData) {
    const iv = combinedData.slice(0, 12);
    const ciphertext = combinedData.slice(12);
    const decrypted = await crypto.subtle.decrypt({ name: "AES-GCM", iv: iv }, symmetricKey, ciphertext);
    return new Uint8Array(decrypted);
}
export function fromHexString(hexString) {
    const normalizedHexString = hexString.startsWith("0x") ? hexString.slice(2) : hexString;
    if (normalizedHexString.length % 2 !== 0) {
        throw new Error("Invalid hex string: length must be even.");
    }
    const byteArray = new Uint8Array(normalizedHexString.length / 2);
    for (let i = 0; i < byteArray.length; i++) {
        byteArray[i] = parseInt(normalizedHexString.substr(i * 2, 2), 16);
    }
    return byteArray;
}
export function toAsciiString(data) {
    return Array.from(data)
        .map((byte) => String.fromCharCode(byte))
        .join("");
}
export async function decryptToAsciiString(symmetricKey, encodedHexString) {
    if (encodedHexString === "") {
        return "";
    }
    const input = fromHexString(encodedHexString);
    const decodedBytes = await decryptData(symmetricKey, input);
    return toAsciiString(decodedBytes);
}
